var _excluded = ["closeMenuOnSelect", "disabled", "error", "errorMessage", "fieldSize", "fieldWidth", "id", "isClearable", "isMulti", "label", "labelledBy", "menuPlacement", "menuWidth", "message", "name", "placeholder", "required", "tabIndex", "value"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import Select from 'react-select';
import styled from 'styled-components';
import * as IconSet from "../../../../icons/index.js";
import Icon from "../../../basic/Icon/Icon.js";
import FieldError from "../../FieldError/FieldError.js";
import FieldLabel from "../../FieldLabel/FieldLabel.js";
import FieldMessage from "../../FieldMessage/FieldMessage.js";
/* style functionality */

var getFieldWidthValue = fieldWidth => {
  var fieldWidthValue = '100%';
  if (typeof fieldWidth === 'number') {
    fieldWidthValue = "".concat(fieldWidth, "px");
  }
  return fieldWidthValue;
};

/* inner components */

var getIndicatorSize = (fieldSize, indicator) => {
  var indicatorSize = 24;
  if (fieldSize === 'small') {
    indicatorSize = 20;
  }
  if (fieldSize === 'large') {
    indicatorSize = 30;
  }
  if (indicator === 'clear') {
    if (fieldSize === 'small') {
      indicatorSize = 14;
    }
    if (fieldSize === 'medium') {
      indicatorSize = 16;
    }
    if (fieldSize === 'large') {
      indicatorSize = 18;
    }
  }
  if (indicator === 'multiValueRemove') {
    indicatorSize = 16;
  }
  return indicatorSize;
};
var StyledClearIndicator = styled(Icon).withConfig({
  componentId: "CL__sc-wwbtrs-0"
})(["margin-left:3px;color:var(--black);outline:none;transition:color var(--hover-transition),opacity var(--hover-transition);[data-theme='dark'] &{color:var(--white);}&:hover{color:var(--red-core);}&:active{opacity:0.75;}&:focus-visible{color:var(--red-core);}"]);
var StyledDropdownIndicator = styled(Icon).withConfig({
  componentId: "CL__sc-wwbtrs-1"
})(["margin-left:3px;outline:none;transition:transform var(--hover-transition);color:var(--black);[data-theme='dark'] &{color:var(--white);}&:focus-visible{background-color:var(--btn-color-focus);border-radius:var(--border-radius-round);box-shadow:inset 0 0 0 2px var(--btn-color-hover);color:var(--btn-color-active);}"]);
var StyledMultiValueRemove = styled(Icon).withConfig({
  componentId: "CL__sc-wwbtrs-2"
})(["background:transparent !important;padding:0 3px 0 0 !important;border-radius:var(--border-radius-small) !important;color:var(--black) !important;outline:none;transition:color var(--hover-transition),opacity var(--hover-transition) !important;&:hover{background-color:transparent !important;color:var(--red-core) !important;}&:active{opacity:0.75 !important;}&:focus-visible{color:var(--red-core) !important;}"]);
var ClearIndicator = props => {
  var {
      selectProps
    } = props,
    restInnerProps = _extends({}, (_objectDestructuringEmpty(props.innerProps), props.innerProps));
  var fieldSize = selectProps.fieldSize || 'medium';
  return /*#__PURE__*/React.createElement(StyledClearIndicator, _extends({
    component: IconSet.CloseCircle,
    size: getIndicatorSize(fieldSize, 'clear'),
    tabIndex: 0
  }, restInnerProps));
};
var DropdownIndicator = props => {
  var {
      selectProps
    } = props,
    restInnerProps = _extends({}, (_objectDestructuringEmpty(props.innerProps), props.innerProps));
  var fieldSize = selectProps.fieldSize || 'medium';
  var menuPlacement = selectProps.menuPlacement || 'bottom';
  return /*#__PURE__*/React.createElement(StyledDropdownIndicator, _extends({
    component: menuPlacement === 'top' ? IconSet.ChevronUp : IconSet.ChevronDown,
    size: getIndicatorSize(fieldSize, 'dropdown'),
    tabIndex: 0
  }, restInnerProps));
};
var MultiValueRemove = props => {
  var {
      selectProps
    } = props,
    restInnerProps = _extends({}, (_objectDestructuringEmpty(props.innerProps), props.innerProps));
  var fieldSize = selectProps.fieldSize || 'medium';
  return /*#__PURE__*/React.createElement(StyledMultiValueRemove, _extends({
    component: IconSet.Close,
    size: getIndicatorSize(fieldSize, 'multiValueRemove'),
    tabIndex: 0
  }, restInnerProps));
};

/* main select element */

var getFieldSizeStyles = fieldSize => {
  var font = 'body-text-small';
  var height = 'var(--spacing-6)';
  var verticalPadding = 6;
  var verticalPaddingWithBorder = 5;
  var padding = "".concat(verticalPadding, "px 0 ").concat(verticalPadding, "px 15px");
  var indicatorPadding = '0 9px 0 0';
  var badgeMargin = '3px 6px 3px 0';
  if (fieldSize === 'small') {
    font = 'body-text-x-small';
    height = 'var(--spacing-4)';
    verticalPadding = 3;
    verticalPaddingWithBorder = 1; /* + space between badges */
    padding = "".concat(verticalPadding, "px 0 ").concat(verticalPadding, "px 9px");
    indicatorPadding = '0 6px 0 0';
    badgeMargin = '1px 6px 1px 0';
  }
  if (fieldSize === 'large') {
    font = 'body-text-medium';
    height = 'var(--spacing-8)';
    verticalPadding = 12;
    verticalPaddingWithBorder = 11;
    padding = "".concat(verticalPadding, "px 0 ").concat(verticalPadding, "px 18px");
    indicatorPadding = '0 12px 0 0';
  }
  return {
    badgeMargin,
    font,
    height,
    indicatorPadding,
    padding,
    verticalPadding,
    verticalPaddingWithBorder
  };
};
var getResultsMenuSizeStyles = fieldSize => {
  var menuPadding = 'var(--spacing-2) var(--spacing-1)';
  var optionFont = 'body-text-small';
  var optionPadding = 'var(--spacing-1) var(--spacing-2)';
  if (fieldSize === 'small') {
    menuPadding = 'var(--spacing-1)';
    optionFont = 'body-text-x-small';
    optionPadding = 'var(--spacing-1) 9px';
  }
  if (fieldSize === 'large') {
    optionFont = 'body-text-medium';
    optionPadding = 'var(--spacing-2) var(--spacing-3)';
  }
  return {
    menuPadding,
    optionFont,
    optionPadding
  };
};
var RSControl = '.react-select__control';
var RSControlOpen = '.react-select__control--menu-is-open:not(.react-select__control--is-disabled)';
var RSControlFocused = '.react-select__control--is-focused:not(.react-select__control--is-disabled)';
var RSControlDisabled = '.react-select__control--is-disabled';
var RSValueContainer = '.react-select__value-container';
var RSMultiValueContainer = '.react-select__value-container--is-multi';
var RSMultiValueContainerWithoutValue = '.react-select__value-container--is-multi:not(.react-select__value-container--has-value)';
var RSMultiValueContainerWithValue = '.react-select__value-container--is-multi.react-select__value-container--has-value';
var RSPlaceholder = '.react-select__placeholder';
var RSInputContainer = '.react-select__input-container';
var RSInput = '.react-select__input';
var RSSingleValue = '.react-select__single-value';
var RSBadge = '.react-select__multi-value';
var RSBadgeText = '.react-select__multi-value__label';
var RSIndicators = '.react-select__indicators';
var RSSelectMenu = '.react-select__menu';
var RSSelectMenuList = '.react-select__menu-list';
var RSSelectMenuOption = '.react-select__option';
var RSSelectMenuOptionFocused = '.react-select__option--is-focused';
var RSSelectMenuOptionSelected = '.react-select__option--is-selected';
var RSSelectMenuNotice = '.react-select__menu-notice';
var StyledSelect = styled(Select).withConfig({
  componentId: "CL__sc-wwbtrs-3"
})(["", "{width:", ";align-content:center;min-height:0;border:1px solid ", ";color:var(--field-text-color);border-radius:var(--border-radius-x-small);background:var(--main-bkg-color);cursor:pointer;box-shadow:none;outline:none;transition:border-color var(--hover-transition);padding:0;font:var(--", ");", ";&:hover{box-shadow:none;border-color:", ";}}", ",", ",", "{margin:0;padding:0;}", "{overflow:hidden;}", "{margin:0 !important;padding:0 !important;}", "{padding:", ";}", "{padding:", ";}", "{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:var(--gray-5);[data-theme='dark'] &{color:var(--gray-4);}}", "{background-color:var(--surface-bkg-color);border-color:var(--border-color-dim);}", ",", "{box-shadow:0 0 5px ", ";border-color:", ";}", " ", "{transform:rotate(180deg);}", "{color:var(--field-text-color);}", "{padding-top:", "px;padding-bottom:", "px;}", "{height:", ";}", "{height:auto;}", "{align-items:center;background-color:var(--gray-2);border-radius:var(--border-radius-small);margin:", ";}", "{color:var(--black);font:var(--body-text-x-small);overflow-wrap:anywhere;padding:0 var(--spacing-1);white-space:normal;}", "{width:", ";padding:", ";margin:0;border-radius:var(--border-radius-x-small);border:1px solid var(--field-border-color);box-shadow:var(--box-shadow-small);", ";background-color:var(--white);[data-theme='dark'] &{background-color:var(--purple-8);}}", "{padding:0;max-height:300px;}", "{color:var(--text-color);cursor:pointer;background-color:transparent;border-radius:var(--border-radius-small);transition-property:background-color,color;transition:var(--hover-transition) var(--transition-easing);outline:none;overflow:hidden;text-overflow:ellipsis;font:var( --", " );padding:", ";&:hover,&:active,&:focus-visible,&", "{color:var(--link-color);}&:hover,&", "{background-color:var(--gray-1);}&:active{background-color:var(--gray-2);}&:focus-visible{background-color:var(--gray-1);}[data-theme='dark'] &:hover,[data-theme='dark'] &", "{background-color:var(--purple-7);}[data-theme='dark'] &:active{background-color:var(--purple-6);}[data-theme='dark'] &:focus-visible{background-color:var(--purple-7);}}", "{font:var( --", " );color:var(--field-text-color);padding:0;}", "{background:var(--purple-core) !important;color:var(--white) !important;[data-theme='dark'] &{background:var(--mint-core) !important;color:var(--black) !important;}}"], RSControl, _ref => {
  var {
    fieldWidth
  } = _ref;
  return getFieldWidthValue(fieldWidth);
}, _ref2 => {
  var {
    error
  } = _ref2;
  return error ? 'var(--error-color)' : 'var(--field-border-color)';
}, _ref3 => {
  var {
    fieldSize
  } = _ref3;
  return getFieldSizeStyles(fieldSize).font;
}, _ref4 => {
  var {
    fieldSize,
    isMulti
  } = _ref4;
  return !isMulti && "height: ".concat(getFieldSizeStyles(fieldSize).height);
}, _ref5 => {
  var {
    error
  } = _ref5;
  return error ? 'var(--error-color)' : 'var(--highlight-color)';
}, RSPlaceholder, RSInputContainer, RSSingleValue, RSInputContainer, RSInput, RSValueContainer, _ref6 => {
  var {
    fieldSize
  } = _ref6;
  return getFieldSizeStyles(fieldSize).padding;
}, RSIndicators, _ref7 => {
  var {
    fieldSize
  } = _ref7;
  return getFieldSizeStyles(fieldSize).indicatorPadding;
}, RSPlaceholder, RSControlDisabled, RSControlFocused, RSControlOpen, _ref8 => {
  var {
    error
  } = _ref8;
  return error ? 'var(--error-color)' : 'var(--highlight-color)';
}, _ref9 => {
  var {
    error
  } = _ref9;
  return error ? 'var(--error-color)' : 'var(--highlight-color)';
}, RSControlOpen, StyledDropdownIndicator, RSSingleValue, RSMultiValueContainer, _ref10 => {
  var {
    fieldSize
  } = _ref10;
  return getFieldSizeStyles(fieldSize).verticalPaddingWithBorder;
}, _ref11 => {
  var {
    fieldSize
  } = _ref11;
  return getFieldSizeStyles(fieldSize).verticalPaddingWithBorder;
}, RSMultiValueContainerWithoutValue, _ref12 => {
  var {
    fieldSize,
    isMulti
  } = _ref12;
  return isMulti && "calc(".concat(getFieldSizeStyles(fieldSize).height, " - 2px)");
}, RSMultiValueContainerWithValue, RSBadge, _ref13 => {
  var {
    fieldSize
  } = _ref13;
  return getFieldSizeStyles(fieldSize).badgeMargin;
}, RSBadgeText, RSSelectMenu, _ref14 => {
  var {
    menuWidth
  } = _ref14;
  return getFieldWidthValue(menuWidth);
}, _ref15 => {
  var {
    fieldSize
  } = _ref15;
  return getResultsMenuSizeStyles(fieldSize).menuPadding;
}, _ref16 => {
  var {
    menuPlacement
  } = _ref16;
  return menuPlacement === 'top' ? 'bottom: calc(100% + 6px);' : 'top: calc(100% + 6px);';
}, RSSelectMenuList, RSSelectMenuOption, _ref17 => {
  var {
    fieldSize
  } = _ref17;
  return getResultsMenuSizeStyles(fieldSize).optionFont;
}, _ref18 => {
  var {
    fieldSize
  } = _ref18;
  return getResultsMenuSizeStyles(fieldSize).optionPadding;
}, RSSelectMenuOptionFocused, RSSelectMenuOptionFocused, RSSelectMenuOptionFocused, RSSelectMenuNotice, _ref19 => {
  var {
    fieldSize
  } = _ref19;
  return getResultsMenuSizeStyles(fieldSize).optionFont;
}, RSSelectMenuOptionSelected);
var SelectMenu = /*#__PURE__*/React.forwardRef((_ref20, ref) => {
  var {
      closeMenuOnSelect = true,
      disabled = false,
      error = false,
      errorMessage = "There's an error with this field",
      fieldSize = 'medium',
      fieldWidth = 'full',
      id = '',
      isClearable = true,
      isMulti = false,
      label,
      labelledBy,
      menuPlacement = 'bottom',
      menuWidth = 'full',
      message,
      name = '',
      placeholder = '',
      required,
      tabIndex = 0,
      value
    } = _ref20,
    props = _objectWithoutProperties(_ref20, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({}, props['data-cy'] && {
    'data-cy': props['data-cy']
  }, props['data-testid'] && {
    'data-testid': props['data-testid']
  }), label && /*#__PURE__*/React.createElement(FieldLabel, {
    fieldSize: fieldSize,
    htmlFor: id,
    required: required
  }, label), /*#__PURE__*/React.createElement(StyledSelect, _extends({
    "aria-label": label,
    "aria-labelledby": labelledBy,
    classNamePrefix: "react-select",
    closeMenuOnSelect: isMulti ? false : closeMenuOnSelect,
    components: {
      IndicatorSeparator: () => null,
      ClearIndicator,
      DropdownIndicator,
      MultiValueRemove
    },
    error: error,
    fieldSize: fieldSize,
    fieldWidth: fieldWidth,
    id: "".concat(id, "-wrapper"),
    inputId: id,
    isClearable: isClearable,
    isDisabled: disabled,
    isMulti: isMulti,
    menuPlacement: menuPlacement,
    menuPosition: "absolute",
    menuWidth: menuWidth,
    name: name,
    placeholder: placeholder,
    required: required,
    tabIndex: tabIndex,
    value: value
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    ,
    ref: ref
  }, props)), message && !error && /*#__PURE__*/React.createElement(FieldMessage, {
    fieldSize: fieldSize,
    htmlFor: id
  }, message), errorMessage && error && /*#__PURE__*/React.createElement(FieldError, {
    fieldSize: fieldSize,
    htmlFor: id
  }, errorMessage));
});
export default SelectMenu;